export function isSinglePrice(canNegotiateNew, canNegotiateUsed, vehicleCondition) {
    return vehicleCondition.toLowerCase() === 'new' ? !canNegotiateNew : !canNegotiateUsed;
}
